<script lang="ts">
	import { format } from 'svelte-i18n';
	import { Text } from '@Shelly/shelly-design-system/index';
	//Helpers
	import TemplateInputSettings from '../../Components/TemplateInputSettings.svelte';
	//Types
	import type { Device } from 'src/types/Device';

	export let device: Device;

	const unit = 'kWh';
	let disabled: boolean = false;
	let value: number = 0;
</script>

<TemplateInputSettings
	{device}
	setting="global_charge_limit"
	min={0}
	max={1000}
	{unit}
	bind:value
	bind:disabled
	withCheckbox
>
	<hr class="mt-s mb-m" />
	<Text styleType="body-small" class="mb-s{disabled ? ' text-color-muted' : ''}"
		>{$format('ev_charger_global_charge_limit', {
			default: 'Configure the EV charger to stop charging when the delivered energy reaches',
		})}
		<span class="mb-s{disabled ? ' text-color-muted' : 'text-primary'}"
			>{disabled || value === null ? '--' : value}</span
		>
		{unit}.
	</Text>
</TemplateInputSettings>
